import React from 'react';
import { Dimensions, Platform, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { getUrls } from '../../config';
import { BaseModal } from '../../ui/components';
import { toggleScreenMirroringModalVisible } from '../../ui/redux';
import { closeDisplaySettings } from '../actions';
import DisplaySettingsTabs from './DisplaySettingsTabs';
import WifiMirroring from './WifiMirroring';

import Theme from '../../theme';
import { WebViewFaqWithBack } from './WebViewFaqWithBack';

const { width } = Dimensions.get('window');
const isMobile = width <= 550;

class DisplaySettingsModalComponent extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);

    const { currentTab } = this.props;
    const availableTabs: any[] = ['Wifi Mirroring'];
    const routes: any[] = [];
    availableTabs.forEach((tabName) => {
      routes.push({
        key: tabName,
        title: tabName,
      });
    });

    this.state = {
      platformAvailable: false,
      expanded: false,
      availableTabs,
      routes,
      index: 0,
      ingredientContainerHeight: 500,
      instructionContainerHeight: 500,
    };
  }

  public renderHeader = (navigationProps: any) => {
    const { availableTabs } = this.state;
    return (
      <DisplaySettingsTabs
        availableTabs={availableTabs}
        setActiveTab={this.handleIndexChange}
        currentTabIndex={this.state.index}
        jumpToIndex={(i) => {
          this.setState({ index: i });
        }}
        routes={navigationProps.navigationState.routes}
        activeTintColor={Theme.PRIMARY}
        inactiveTintColor={Theme.GREY}
        activeBackgroundColor={Theme.WHITE}
        inactiveBackgroundColor={Theme.WHITE}
      />
    );
  };

  public renderScene = ({ route }) => (<WifiMirroring />);

  public handleIndexChange = (index) => {
    this.setState({ index });
  };

  public closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal(false);
  };

  public render() {
    const {
      screenMirroringModalVisible,
    } = this.props;
    const { SCREEN_CASTING_FAQ_IOS, SCREEN_CASTING_FAQ_ANDROID } = getUrls();
    const SCREEN_CASTING_FAQ = Platform.OS === 'ios' ? SCREEN_CASTING_FAQ_IOS : SCREEN_CASTING_FAQ_ANDROID;
    const paddingBottom = Platform.OS === 'ios' ? 0 : 20;
    return (
      <BaseModal
        title='Display your workout on your TV (recommended)'
        closeIconSize={35}
        bodyStyle={{ backgroundColor: Theme.BLACK, padding: 0 }}
        headerTextColor={{ color: Theme.WHITE }}
        headerTextStyle={{ paddingVertical: 10, padding: 5 }}
        modalContainer={{ backgroundColor: Theme.BLACK, paddingBottom }}
        isModalVisible={screenMirroringModalVisible}
        closeModal={this.closeModal}
      >
        <WebViewFaqWithBack url={SCREEN_CASTING_FAQ} />
      </BaseModal>
    );
  }
}

const styles = StyleSheet.create({
  borderRight: {
    borderRightWidth: 0.5,
    borderRightColor: Theme.GREY,
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: Theme.GREY,
  },
  sectionContainer: {
    width: '100%',
  },
  sectionHeading: {
    color: Theme.BLACK,
    fontSize: 17,
    fontFamily: Theme.Custom500,
  },
  verticalSeparator: {
    width: 1,
    marginHorizontal: 10,
    backgroundColor: Theme.GREY_LIGHT,
  },
  horizontalSeparator: {
    borderBottomWidth: 1,
    marginVertical: 10,
    borderBottomColor: Theme.GREY_LIGHT,

  },
});

const mapStateToProps = (state: any) => {
  const { screenMirroringModalVisible } = state.ui;
  return {
    screenMirroringModalVisible,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  closeDisplaySettings: () => dispatch(closeDisplaySettings()),
  toggleModal: (visible: boolean) => dispatch(toggleScreenMirroringModalVisible(visible)),
});

export const DisplaySettingsModal = connect(mapStateToProps, mapDispatchToProps)(DisplaySettingsModalComponent);
